import React from 'react'
import { notification, Button } from 'antd'
import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getStaticGallery,
  createGallery,
  removeGallery,
  getSubGalleryByGallery,
  getGalleryByUuid,
  updateGallery,
} from 'services/gallery'
import actions from './action'

export function* getStaticGallerySage() {
  try {
    const result = yield call(getStaticGallery)
    console.log('result ====>>>>>', result)
    const { data } = result
    const { gallery } = data
    if (result.status === 200) {
      yield put({
        type: 'gallery/SET_STATE',
        payload: {
          mainGallery: gallery,
          totalmainGallery: gallery.length,
          isGalleryCreated: false,
          isDeleted: false,
          isUpdated: false,
          loading: false,
          uuid: null,
        },
      })
    }
  } catch (err) {
    notification.error({
      message: 'Error',
      description: `Some Error Occured. Please try again.\n Error: ${JSON.stringify(err)}`,
      duration: 0,
    })
    yield put({
      type: 'gallery/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* getSubGalleryByGallerySaga(payload) {
  try {
    const { body } = payload
    const result = yield call(getSubGalleryByGallery, body)
    const { data } = result
    if (result.status === 200) {
      yield put({
        type: 'gallery/SET_STATE',
        payload: {
          subGallery: data.data,
          totalSubGallery: data.meta.total,
          isGalleryCreated: false,
          isDeleted: false,
          isUpdated: false,
          loading: false,
          uuid: null,
        },
      })
    }
  } catch (err) {
    notification.error({
      message: 'Error',
      description: `Some Error Occured. Please try again.\n Error: ${JSON.stringify(err)}`,
      duration: 0,
    })
    yield put({
      type: 'gallery/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* createGallerySaga(payload) {
  try {
    yield put({
      type: 'gallery/SET_STATE',
      payload: {
        loading: true,
      },
    })
    const { body } = payload
    const result = yield call(createGallery, body)
    console.log('result ====>>>>>', result)
    if (result.status === 200) {
      yield put({
        type: 'gallery/SET_STATE',
        payload: {
          isGalleryCreated: true,
          isDeleted: false,
          isUpdated: false,
          loading: false,
          uuid: result.data.data.uuid,
        },
      })
      notification.success({
        message: 'Success',
        description: 'Gallery has been created successfully',
      })
    }
  } catch (err) {
    notification.error({
      message: 'Error',
      description: `Some Error Occured. Please try again.\n Error: ${JSON.stringify(err)}`,
      duration: 0,
    })
    yield put({
      type: 'gallery/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* removeGallerySaga(payload) {
  try {
    const { uuid } = payload
    const result = yield call(removeGallery, uuid)
    console.log('result ====>>>>>', result)
    if (result.status === 200) {
      yield put({
        type: 'gallery/SET_STATE',
        payload: {
          isGalleryCreated: false,
          isDeleted: true,
          isUpdated: false,
          loading: false,
          uuid: null,
        },
      })
      notification.success({
        message: 'Success',
        description: 'Gallery is deleted Successfully',
      })
    }
  } catch (err) {
    notification.error({
      message: 'Error',
      description: `Some Error Occured. Please try again.\n Error: ${JSON.stringify(err)}`,
      duration: 0,
    })
    yield put({
      type: 'gallery/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* getGalleyByUuidSaga(body) {
  try {
    const result = yield call(getGalleryByUuid, body)
    const { data } = result
    if (result.status === 200) {
      yield put({
        type: 'gallery/SET_STATE',
        payload: {
          editGallery: data.data,
          isGalleryCreated: false,
          isDeleted: false,
          isUpdated: false,
          loading: false,
          uuid: null,
        },
      })
    }
  } catch (err) {
    const key = `${Date.now()}`
    notification.error({
      message: 'Error',
      description: `Some Error Occured. Please try again.`,
      key,
      btn: (
        <Button
          type="primary"
          size="small"
          onClick={() => {
            notification.close(key)
            document.location.reload()
          }}
        >
          Reload
        </Button>
      ),
      duration: 0,
    })
    yield put({
      type: 'gallery/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* updateGallerySaga(payload) {
  try {
    yield put({
      type: 'gallery/SET_STATE',
      payload: {
        loading: true,
      },
    })
    const { body, uuid } = payload.payload
    const result = yield call(updateGallery, uuid, { data: body })
    if (result.status === 200) {
      yield put({
        type: 'gallery/SET_STATE',
        payload: {
          editGallery: '',
          isGalleryCreated: false,
          isDeleted: false,
          isUpdated: true,
          loading: false,
          uuid: null,
        },
      })
      notification.success({
        message: 'Success',
        description: 'Gallery is updated successfully',
      })
    }
  } catch (err) {
    notification.error({
      message: 'Error',
      description: `Some Error Occured. Please try again.\n Error: ${JSON.stringify(err)}`,
      duration: 0,
    })
    yield put({
      type: 'gallery/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_GALLERY_LIST, getStaticGallerySage),
    takeEvery(actions.CREATE_GALLERY, createGallerySaga),
    takeEvery(actions.REMOVE_GALLERY, removeGallerySaga),
    takeEvery(actions.GET_SUB_GALLERY, getSubGalleryByGallerySaga),
    takeEvery(actions.GET_GALLERY_BY_ID, getGalleyByUuidSaga),
    takeEvery(actions.UPDATE_GALLERY, updateGallerySaga),
  ])
}
